import React from 'react'

import PopupMenuButton from "../../popover-menu/popup-menu-button/popup-menu-button"
import RelatedItemAddMenu, {RELATED_ITEMS_ADD_POPOVER_CLASS, RelatedItemAddHandler} from "./add-menu"

type Props = {
    className?  : string        // the host's own box: height, left padding, margins
    label       : string
    onAdd       : RelatedItemAddHandler
}

// The "+ Add related item" line, shared by the popover and the task block.
//
// It is NOT styled like a row: the plus is blue (`action`) and the text is the
// lighter `ui5-link-add-item`, so it reads as an action rather than as another
// related item -- the same pair `AddItem` renders elsewhere. `fs-14` bumps its
// font-size to match the Todo list's rows -- `ui5-link-add-item` itself is
// $font-size-small (13px) and, unlike the `ui5-txt-*` family, has no default-size
// variant to swap to.
//
// The sizing is what keeps it aligned: the plus matches RelatedItemIcon's own
// width and right margin, so given the same left inset as a row (the host's
// className) it lands directly under the row icons and the label under the row
// titles. Change one and change the other.
//
// It opens the type menu rather than the selector modal -- see add-menu.tsx. The
// host's className goes on the PopupMenuButton ROOT, so a host that dresses this
// as a menu row (`.option` in the document popover) still styles the row itself.
export default function RelatedItemAddLink(props: Props) {

    // A fragment, so the plus and the label stay DIRECT children of the root --
    // `.option` styles its children, and a wrapper would break that host.
    const btnComponent = () => (
        <>
            <div className="ui5-ico-13 i5-plus action m-r-6"/>
            <div className="ui5-link-add-item fs-14">{props.label}</div>
        </>
    )

    return (
        <PopupMenuButton
            className        = {Classes("flex-row-left-center", props.className)}
            popoverClass     = {RELATED_ITEMS_ADD_POPOVER_CLASS}
            attachment       = "top left"
            targetAttachment = "bottom left"
            offset           = "0 0"
            btnComponent     = {btnComponent}
            menuComponent    = {RelatedItemAddMenu}
            menuParams       = {{onAdd: props.onAdd}}
        />
    )
}
